import { makeStyles, shorthands } from '@fluentui/react-components';

export const usePageStyles = makeStyles({
  main: {
    position: 'relative',
    overflow: 'auto',
    '&:after': {
      content: '""',
      display: 'block',
      clear: 'both',
    },
    ...shorthands.padding('16px', '26px', '8px'),
  },

  cardSmall: {
    width: '33.3%',
  },
  cardMedium: {
    width: '50%',
  },
  cardLarge: {
    width: '66.6%',
  },
  cardFull: {
    width: '100%',
  },
  column: {
    height: '430px',
    '& .overview-card': {
      height: '410px',
    },
  },
});
